// Central bilingual content for Jorviko. Values are {en, no} objects consumed via t().

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/166d62d2-95f9-4195-8192-05ff5b786272/images/38135f2684c583582ee4b117b9bb753be6b94f6cd637028d0f99c489130f4966.jpeg",
  sphere: "https://static.prod-images.emergentagent.com/jobs/166d62d2-95f9-4195-8192-05ff5b786272/images/8dd3483581c939ee173209663a78675be98159fd940aa66f71bf7e1d3bd4fb4d.jpeg",
  neural: "https://static.prod-images.emergentagent.com/jobs/166d62d2-95f9-4195-8192-05ff5b786272/images/d90ccf9c5b131c621c7d5e66a69728c8c84de62ede7705ccffbb1a40e035b5bd.jpeg",
  cloud: "https://static.prod-images.emergentagent.com/jobs/166d62d2-95f9-4195-8192-05ff5b786272/images/187de7e670f1817075aff2d81518a651a96d3d4c0b1795e87d4164d751cb6e96.jpeg",
};

// Services power both the homepage "What Can We Help You Build?" cards and the
// four dedicated /services/<slug> landing pages.
export const SERVICES = {
  overline: { en: "What Can We Help You Build?", no: "Hva kan vi hjelpe deg med å bygge?" },
  title: { en: "Four ways we help businesses build better technology.", no: "Fire måter vi hjelper bedrifter med å bygge bedre teknologi." },
  items: [
    {
      slug: "software-development",
      icon: "LayoutGrid",
      name: { en: "Custom Software", no: "Skreddersydd programvare" },
      desc: {
        en: "Custom applications, SaaS products and internal systems designed around how your business actually works.",
        no: "Skreddersydde applikasjoner, SaaS-produkter og interne systemer designet rundt hvordan virksomheten din faktisk fungerer.",
      },
      examples: [
        { en: "SaaS products & platforms", no: "SaaS-produkter og -plattformer" },
        { en: "Internal business systems", no: "Interne forretningssystemer" },
        { en: "Customer portals", no: "Kundeportaler" },
        { en: "Admin dashboards", no: "Administrasjonspaneler" },
        { en: "Booking and order systems", no: "Booking- og ordresystemer" },
        { en: "Document management", no: "Dokumenthåndtering" },
        { en: "Data-driven applications", no: "Datadrevne applikasjoner" },
        { en: "Legacy system replacement", no: "Utskifting av gamle systemer" },
        { en: "APIs and integrations", no: "API-er og integrasjoner" },
      ],
      cta: { en: "Explore Software Development", no: "Utforsk programvareutvikling" },
    },
    {
      slug: "ai-automation",
      icon: "Sparkles",
      name: { en: "AI & Automation", no: "AI og automatisering" },
      desc: {
        en: "Practical AI and automation that reduces repetitive work and helps your team work faster.",
        no: "Praktisk AI og automatisering som reduserer repetitivt arbeid og hjelper teamet ditt å jobbe raskere.",
      },
      examples: [
        { en: "AI assistants", no: "AI-assistenter" },
        { en: "AI agents", no: "AI-agenter" },
        { en: "Document search with AI", no: "Dokumentsøk med AI" },
        { en: "Document extraction", no: "Dokumentuttrekk" },
        { en: "Workflow automation", no: "Arbeidsflytautomatisering" },
        { en: "Customer service automation", no: "Automatisering av kundeservice" },
        { en: "AI-powered analysis", no: "AI-drevet analyse" },
        { en: "RAG and enterprise knowledge systems", no: "RAG og kunnskapssystemer for virksomheter" },
      ],
      cta: { en: "Explore AI & Automation", no: "Utforsk AI og automatisering" },
    },
    {
      slug: "web-development",
      icon: "Globe",
      name: { en: "Websites & Web Applications", no: "Nettsider og webapplikasjoner" },
      desc: {
        en: "Modern websites and web applications built for businesses that need more than a template.",
        no: "Moderne nettsider og webapplikasjoner bygget for bedrifter som trenger mer enn en mal.",
      },
      examples: [
        { en: "Business websites", no: "Bedriftsnettsider" },
        { en: "Custom web applications", no: "Skreddersydde webapplikasjoner" },
        { en: "Customer portals", no: "Kundeportaler" },
        { en: "Admin systems", no: "Administrasjonssystemer" },
        { en: "Product catalogues", no: "Produktkataloger" },
        { en: "Booking systems", no: "Bookingsystemer" },
        { en: "Lead generation", no: "Leadgenerering" },
        { en: "Hosting and maintenance", no: "Hosting og vedlikehold" },
      ],
      cta: { en: "Explore Web Development", no: "Utforsk webutvikling" },
    },
    {
      slug: "cloud-modernisation",
      icon: "Cloud",
      name: { en: "Cloud & Modernisation", no: "Sky og modernisering" },
      desc: {
        en: "Modernise existing systems, connect your technology and move outdated processes into the cloud.",
        no: "Moderniser eksisterende systemer, koble sammen teknologien din og flytt utdaterte prosesser til skyen.",
      },
      examples: [
        { en: "Azure solutions", no: "Azure-løsninger" },
        { en: "Cloud architecture", no: "Skyarkitektur" },
        { en: "Application modernisation", no: "Modernisering av applikasjoner" },
        { en: "System integrations", no: "Systemintegrasjoner" },
        { en: "API development", no: "API-utvikling" },
        { en: "Legacy migration", no: "Migrering av gamle systemer" },
        { en: "Security", no: "Sikkerhet" },
        { en: "Scalable infrastructure", no: "Skalerbar infrastruktur" },
      ],
      cta: { en: "Explore Cloud Solutions", no: "Utforsk skyløsninger" },
    },
  ],
};

export const NAV = [
  { to: "/", label: { en: "Home", no: "Hjem" } },
  {
    to: "/services",
    label: { en: "Services", no: "Tjenester" },
    children: SERVICES.items.map((s) => ({ to: `/services/${s.slug}`, label: s.name })),
  },
  { to: "/solutions", label: { en: "Solutions", no: "Løsninger" } },
  { to: "/about", label: { en: "About", no: "Om oss" } },
  { to: "/ikke-alene", label: { en: "Ikke Alene", no: "Ikke Alene" } },
  { to: "/contact", label: { en: "Contact", no: "Kontakt" } },
];

export const HERO = {
  eyebrow: { en: "Software · AI · Automation", no: "Programvare · AI · Automatisering" },
  h1a: { en: "Software, AI & Automation", no: "Programvare, AI og automatisering" },
  h1b: { en: "Built Around Your Business.", no: "Bygget rundt din virksomhet." },
  sub: {
    en: "Jorviko helps businesses turn ideas and manual processes into modern software. From websites and internal systems to AI assistants, automation and cloud solutions, we design and build technology that solves real business problems.",
    no: "Jorviko hjelper bedrifter med å gjøre ideer og manuelle prosesser om til moderne programvare. Fra nettsider og interne systemer til AI-assistenter, automatisering og skyløsninger — vi designer og bygger teknologi som løser reelle forretningsproblemer.",
  },
  cta: { en: "Discuss Your Project", no: "Diskuter ditt prosjekt" },
  cta2: { en: "Explore Our Services", no: "Utforsk våre tjenester" },
  credibility: { en: "Software Engineering · AI · Cloud · Based in Norway", no: "Programvareutvikling · AI · Sky · Basert i Norge" },
  scroll: { en: "Scroll to explore", no: "Rull for å utforske" },
};

export const SOLVE = {
  overline: { en: "Problems We Solve", no: "Problemer vi løser" },
  title: { en: "Do any of these sound familiar?", no: "Kjenner du deg igjen i noe av dette?" },
  cards: [
    {
      icon: "FileSpreadsheet",
      title: { en: "Still running important processes in Excel?", no: "Kjører du fortsatt viktige prosesser i Excel?" },
      text: {
        en: "We can turn spreadsheets and manual workflows into a secure business application built around your process.",
        no: "Vi kan gjøre regneark og manuelle arbeidsflyter om til en sikker forretningsapplikasjon bygget rundt din prosess.",
      },
    },
    {
      icon: "Search",
      title: { en: "Spending hours searching through documents?", no: "Bruker du timer på å søke gjennom dokumenter?" },
      text: {
        en: "We can build an AI assistant that understands your company's documents and helps employees find answers quickly.",
        no: "Vi kan bygge en AI-assistent som forstår bedriftens dokumenter og hjelper ansatte med å finne svar raskt.",
      },
    },
    {
      icon: "Network",
      title: { en: "Your systems don't talk to each other?", no: "Snakker ikke systemene dine sammen?" },
      text: {
        en: "We connect applications, APIs and data sources so information moves automatically between your systems.",
        no: "Vi kobler sammen applikasjoner, API-er og datakilder slik at informasjon flyter automatisk mellom systemene dine.",
      },
    },
    {
      icon: "Globe",
      title: { en: "Need more than a basic website?", no: "Trenger du mer enn en enkel nettside?" },
      text: {
        en: "We build websites that can include customer portals, administration tools, booking, product management and custom business functionality.",
        no: "Vi bygger nettsider som kan inkludere kundeportaler, administrasjonsverktøy, booking, produkthåndtering og skreddersydd forretningsfunksjonalitet.",
      },
    },
    {
      icon: "Repeat",
      title: { en: "Too much repetitive manual work?", no: "For mye repetitivt manuelt arbeid?" },
      text: {
        en: "We identify repetitive workflows and automate them using software, integrations and AI.",
        no: "Vi identifiserer repetitive arbeidsflyter og automatiserer dem med programvare, integrasjoner og AI.",
      },
    },
  ],
};

// "Solutions We Can Build" — example solutions, clearly labelled as examples, not case studies.
export const SOLUTIONS = {
  overline: { en: "Solutions We Can Build", no: "Løsninger vi kan bygge" },
  title: { en: "Solutions we can build.", no: "Løsninger vi kan bygge." },
  sub: {
    en: "Every business is different. Here are examples of how software and AI can solve everyday business problems.",
    no: "Hver virksomhet er ulik. Her er eksempler på hvordan programvare og AI kan løse dagligdagse forretningsproblemer.",
  },
  labelTag: { en: "Example solution", no: "Eksempel på løsning" },
  items: [
    {
      industry: { en: "Product & inventory businesses", no: "Virksomheter med produkter og lagerbeholdning" },
      name: { en: "Website + inventory management system", no: "Nettside + lagerstyringssystem" },
      value: {
        en: "Any business that manages a catalogue of products or inventory — vehicles, equipment, real estate, retail stock and more — can manage it all through an admin portal, upload images and specifications, automatically publish it to the website and receive customer enquiries.",
        no: "Enhver virksomhet som administrerer en katalog av produkter eller lagerbeholdning — kjøretøy, utstyr, eiendom, butikkvarer og mer — kan administrere alt gjennom en administrasjonsportal, laste opp bilder og spesifikasjoner, publisere det automatisk til nettsiden og motta kundehenvendelser.",
      },
      features: [
        { en: "Inventory administration", no: "Lagerstyring" },
        { en: "Image upload", no: "Bildeopplasting" },
        { en: "Inventory website", no: "Lagernettside" },
        { en: "Enquiry management", no: "Henvendelseshåndtering" },
        { en: "Analytics", no: "Analyse" },
      ],
    },
    {
      industry: { en: "Construction company", no: "Entreprenørbedrift" },
      name: { en: "Project and document platform", no: "Prosjekt- og dokumentplattform" },
      value: {
        en: "Create a central place for project documentation with AI-powered document search and workflow automation.",
        no: "Skap et sentralt sted for prosjektdokumentasjon med AI-drevet dokumentsøk og arbeidsflytautomatisering.",
      },
      features: [
        { en: "Document management", no: "Dokumenthåndtering" },
        { en: "AI search", no: "AI-søk" },
        { en: "Project dashboards", no: "Prosjektdashbord" },
        { en: "Automated workflows", no: "Automatiserte arbeidsflyter" },
        { en: "Role-based access", no: "Rollebasert tilgang" },
      ],
    },
    {
      industry: { en: "Consulting company", no: "Konsulentselskap" },
      name: { en: "Client portal + reporting automation", no: "Kundeportal + rapportautomatisering" },
      value: {
        en: "Build a secure customer portal where clients can access reports, documents and project information.",
        no: "Bygg en sikker kundeportal hvor klienter kan få tilgang til rapporter, dokumenter og prosjektinformasjon.",
      },
      features: [
        { en: "Client portal", no: "Kundeportal" },
        { en: "Automated reports", no: "Automatiserte rapporter" },
        { en: "Microsoft 365 integration", no: "Microsoft 365-integrasjon" },
        { en: "Notifications", no: "Varsler" },
        { en: "Secure document access", no: "Sikker dokumenttilgang" },
      ],
    },
    {
      industry: { en: "Growing SME", no: "Voksende SMB" },
      name: { en: "Replace spreadsheets with a business system", no: "Erstatt regneark med et forretningssystem" },
      value: {
        en: "Transform Excel-based operational processes into a custom application.",
        no: "Gjør Excel-baserte driftsprosesser om til en skreddersydd applikasjon.",
      },
      features: [
        { en: "Centralised data", no: "Sentralisert data" },
        { en: "Dashboards", no: "Dashbord" },
        { en: "Approval workflows", no: "Godkjenningsflyter" },
        { en: "User roles", no: "Brukerroller" },
        { en: "Reporting", no: "Rapportering" },
        { en: "Automation", no: "Automatisering" },
      ],
    },
  ],
};

export const TECH = {
  overline: { en: "Technology", no: "Teknologi" },
  title: { en: "Technology behind the solutions.", no: "Teknologien bak løsningene." },
  groups: [
    { label: { en: "AI", no: "AI" }, items: ["OpenAI", "Azure AI", "LLMs", "AI Agents", "RAG"] },
    { label: { en: "Backend", no: "Backend" }, items: ["Python", ".NET", "FastAPI", "APIs"] },
    { label: { en: "Frontend", no: "Frontend" }, items: ["React", "TypeScript", "Modern Web"] },
    { label: { en: "Cloud", no: "Sky" }, items: ["Microsoft Azure", "Azure App Service", "Azure Functions", "Azure SQL", "Cloud-Native"] },
    { label: { en: "Data", no: "Data" }, items: ["SQL", "Data Pipelines", "Analytics", "Power BI"] },
  ],
};

export const WHY = {
  overline: { en: "Why Jorviko", no: "Hvorfor Jorviko" },
  title: { en: "Why businesses choose to work with us.", no: "Hvorfor bedrifter velger å jobbe med oss." },
  items: [
    {
      icon: "Cpu",
      title: { en: "Engineering first", no: "Ingeniørkunst først" },
      desc: { en: "We build real software products, not just presentations or AI demos.", no: "Vi bygger ekte programvareprodukter — ikke bare presentasjoner eller AI-demoer." },
    },
    {
      icon: "Puzzle",
      title: { en: "Built around your business", no: "Bygget rundt din virksomhet" },
      desc: {
        en: "We don't force your company into a generic template. The solution is designed around your workflows and goals.",
        no: "Vi presser ikke virksomheten din inn i en generisk mal. Løsningen designes rundt dine arbeidsflyter og mål.",
      },
    },
    {
      icon: "Sparkles",
      title: { en: "AI where it creates value", no: "AI der det skaper verdi" },
      desc: { en: "We use AI when it solves a real problem, not simply because it is fashionable.", no: "Vi bruker AI når det løser et reelt problem — ikke bare fordi det er trendy." },
    },
    {
      icon: "Rocket",
      title: { en: "From idea to production", no: "Fra idé til produksjon" },
      desc: {
        en: "We can help with strategy, design, development, cloud deployment and ongoing improvements.",
        no: "Vi kan hjelpe med strategi, design, utvikling, skydrift og løpende forbedringer.",
      },
    },
    {
      icon: "Code2",
      title: { en: "Modern technology", no: "Moderne teknologi" },
      desc: {
        en: "We build using modern, scalable technologies including Python, .NET, React, Azure and leading AI platforms.",
        no: "Vi bygger med moderne, skalerbare teknologier som Python, .NET, React, Azure og ledende AI-plattformer.",
      },
    },
  ],
};

export const PROCESS = {
  overline: { en: "How We Work", no: "Hvordan vi jobber" },
  title: { en: "A simple, transparent process from idea to launch.", no: "En enkel og transparent prosess fra idé til lansering." },
  steps: [
    { n: "01", name: { en: "Understand", no: "Forstå" }, desc: { en: "We learn about your business, problem and goals.", no: "Vi setter oss inn i virksomheten din, problemet og målene dine." } },
    { n: "02", name: { en: "Design", no: "Design" }, desc: { en: "We define the solution, architecture and user experience.", no: "Vi definerer løsningen, arkitekturen og brukeropplevelsen." } },
    { n: "03", name: { en: "Prototype", no: "Prototype" }, desc: { en: "We create an early version so you can see and test the idea.", no: "Vi lager en tidlig versjon slik at du kan se og teste ideen." } },
    { n: "04", name: { en: "Build", no: "Bygg" }, desc: { en: "We develop, integrate and test the production solution.", no: "Vi utvikler, integrerer og tester produksjonsløsningen." } },
    { n: "05", name: { en: "Launch & Improve", no: "Lansering og forbedring" }, desc: { en: "We deploy the solution and can continue supporting and improving it.", no: "Vi lanserer løsningen og kan fortsette å støtte og forbedre den." } },
  ],
  cta: { en: "Start a Conversation", no: "Start en samtale" },
};

export const BUSINESS_STAGES = {
  overline: { en: "Who We Work With", no: "Hvem vi jobber med" },
  title: { en: "Built for businesses of every stage.", no: "Bygget for bedrifter i alle faser." },
  sub: {
    en: "Jorviko supports both smaller businesses and larger organisations — the solution scales with you.",
    no: "Jorviko støtter både mindre bedrifter og større organisasjoner — løsningen skalerer med deg.",
  },
  items: [
    {
      icon: "Store",
      name: { en: "Small businesses", no: "Små bedrifter" },
      desc: { en: "Professional websites, booking systems, automation and custom tools.", no: "Profesjonelle nettsider, bookingsystemer, automatisering og skreddersydde verktøy." },
    },
    {
      icon: "TrendingUp",
      name: { en: "Growing companies", no: "Voksende selskaper" },
      desc: { en: "Internal systems, customer portals, integrations and workflow automation.", no: "Interne systemer, kundeportaler, integrasjoner og arbeidsflytautomatisering." },
    },
    {
      icon: "Building2",
      name: { en: "Enterprise teams", no: "Enterprise-team" },
      desc: { en: "AI solutions, cloud architecture, intelligent applications and complex integrations.", no: "AI-løsninger, skyarkitektur, intelligente applikasjoner og komplekse integrasjoner." },
    },
  ],
};

export const CONTACT = {
  overline: { en: "Contact", no: "Kontakt" },
  title: { en: "Have a process that should work better?", no: "Har du en prosess som burde fungere bedre?" },
  sub: {
    en: "Tell us what you are trying to build, automate or improve. We can help turn the idea into a practical solution.",
    no: "Fortell oss hva du prøver å bygge, automatisere eller forbedre. Vi kan hjelpe deg med å gjøre ideen om til en praktisk løsning.",
  },
  cta: { en: "Discuss Your Project", no: "Diskuter ditt prosjekt" },
  cta2: { en: "Contact Jorviko", no: "Kontakt Jorviko" },
  helper: { en: "You don't need a technical specification. Start by explaining the problem.", no: "Du trenger ikke en teknisk spesifikasjon. Start med å forklare problemet." },
  fields: {
    name: { en: "Full name", no: "Fullt navn" },
    email: { en: "Work email", no: "Jobb-e-post" },
    company: { en: "Company", no: "Selskap" },
    role: { en: "Role", no: "Rolle" },
    interest: { en: "Area of interest", no: "Interesseområde" },
    message: { en: "Tell us about your challenge", no: "Fortell oss om utfordringen din" },
    submit: { en: "Discuss Your Project", no: "Diskuter ditt prosjekt" },
    sending: { en: "Sending…", no: "Sender…" },
    success: { en: "Thank you — we'll be in touch within 24 hours.", no: "Takk — vi tar kontakt innen 24 timer." },
    error: { en: "Something went wrong. Please try again.", no: "Noe gikk galt. Prøv igjen." },
  },
};

// /about — company positioning. Deliberately avoids invented numbers, customers or superlatives.
export const ABOUT = {
  hero: {
    overline: { en: "About Jorviko", no: "Om Jorviko" },
    title: { en: "Turning real business problems into useful technology.", no: "Gjør reelle forretningsproblemer om til nyttig teknologi." },
    subtitle: {
      en: "Jorviko is a Norwegian software and AI company. We build practical technology, not experiments.",
      no: "Jorviko er et norsk programvare- og AI-selskap. Vi bygger praktisk teknologi, ikke eksperimenter.",
    },
  },
  intro: {
    heading: { en: "Who we are", no: "Hvem vi er" },
    paragraphs: [
      {
        en: "Jorviko is a Norwegian software and AI company focused on turning real business problems into useful technology.",
        no: "Jorviko er et norsk programvare- og AI-selskap som fokuserer på å gjøre reelle forretningsproblemer om til nyttig teknologi.",
      },
      {
        en: "We work across software engineering, AI, automation, cloud, data and web applications — combining these disciplines depending on what a business actually needs.",
        no: "Vi jobber på tvers av programvareutvikling, AI, automatisering, sky, data og webapplikasjoner — og kombinerer disse fagfeltene ut fra hva virksomheten faktisk trenger.",
      },
      {
        en: "We are a young company. Rather than make claims about scale or track record, we'd rather show you how we think and how we build.",
        no: "Vi er et ungt selskap. Fremfor å komme med påstander om størrelse eller merittliste, viser vi heller hvordan vi tenker og hvordan vi bygger.",
      },
    ],
  },
  areas: {
    heading: { en: "What we work across", no: "Hva vi jobber med" },
    items: [
      { en: "Software Engineering", no: "Programvareutvikling" },
      { en: "AI", no: "AI" },
      { en: "Automation", no: "Automatisering" },
      { en: "Cloud", no: "Sky" },
      { en: "Data", no: "Data" },
      { en: "Web Applications", no: "Webapplikasjoner" },
    ],
  },
  values: {
    heading: { en: "What we focus on", no: "Hva vi vektlegger" },
    items: [
      { icon: "Cpu", title: { en: "Technical experience", no: "Teknisk erfaring" }, desc: { en: "Engineering backgrounds across software, AI and cloud systems.", no: "Ingeniørbakgrunn innen programvare, AI og skysystemer." } },
      { icon: "ShieldCheck", title: { en: "Engineering quality", no: "Ingeniørkvalitet" }, desc: { en: "We build systems meant to run in production, not just demos.", no: "Vi bygger systemer som er ment å kjøre i produksjon — ikke bare demoer." } },
      { icon: "Puzzle", title: { en: "Practical problem solving", no: "Praktisk problemløsning" }, desc: { en: "We start from your problem, not from a piece of technology we want to use.", no: "Vi starter med problemet ditt, ikke med en teknologi vi vil bruke." } },
      { icon: "Code2", title: { en: "Modern technologies", no: "Moderne teknologi" }, desc: { en: "Python, .NET, React, Azure and leading AI platforms.", no: "Python, .NET, React, Azure og ledende AI-plattformer." } },
      { icon: "Users", title: { en: "Close collaboration", no: "Tett samarbeid" }, desc: { en: "We work closely with your team throughout, not behind closed doors.", no: "Vi jobber tett med teamet ditt gjennom hele prosessen, ikke bak lukkede dører." } },
    ],
  },
};

// Homepage teaser section linking to the /ikke-alene vision page.
export const SOCIAL_IMPACT = {
  eyebrow: { en: "Our wider purpose", no: "Vårt større formål" },
  title: { en: "Technology with a purpose", no: "Teknologi med et større formål" },
  desc: {
    en: "Jorviko was founded with a wider ambition: to use technology not only to improve businesses, but also to support ideas that can create meaningful social impact.",
    no: "Jorviko ble etablert med en større ambisjon: å bruke teknologi ikke bare til å forbedre virksomheter, men også til å støtte ideer som kan skape positiv samfunnseffekt.",
  },
  projectTitle: "Ikke Alene",
  projectText: {
    en: "Ikke Alene is an early-stage vision exploring how responsible technology and stronger human connection could make it easier for people to express how they feel, check in with trusted people and find appropriate support earlier.",
    no: "Ikke Alene er en visjon i en tidlig fase som utforsker hvordan ansvarlig teknologi og sterkere menneskelig kontakt kan gjøre det enklere å uttrykke hvordan man har det, sjekke inn med personer man stoler på og finne riktig støtte tidligere.",
  },
  cta: { en: "Discover the Ikke Alene vision", no: "Oppdag Ikke Alene-visjonen" },
};

// /ikke-alene — early-stage social-impact vision page.
export const IKKE_ALENE = {
  seo: {
    title: {
      en: "Ikke Alene | A responsible technology vision by Jorviko",
      no: "Ikke Alene | En ansvarlig teknologivisjon fra Jorviko",
    },
    desc: {
      en: "Learn about Ikke Alene, Jorviko's early-stage vision for responsible technology that supports human connection, earlier outreach and appropriate support.",
      no: "Les om Ikke Alene, Jorvikos tidlige visjon for ansvarlig teknologi som støtter menneskelig kontakt, tidligere dialog og tilgang til riktig støtte.",
    },
  },
  hero: {
    eyebrow: { en: "A Jorviko social-impact vision", no: "En samfunnsrettet visjon fra Jorviko" },
    title: { en: "No one should have to feel alone", no: "Ingen skal måtte føle seg alene" },
    intro: {
      en: "Ikke Alene is a long-term vision focused on creating safer and simpler ways for people to express how they feel, stay connected with trusted people and take an earlier step towards appropriate support.",
      no: "Ikke Alene er en langsiktig visjon med mål om å skape tryggere og enklere måter å uttrykke hvordan man har det, holde kontakt med personer man stoler på og ta et tidligere steg mot riktig støtte.",
    },
    ctaPrimary: { en: "Contribute to the vision", no: "Bidra til visjonen" },
    ctaSecondary: { en: "Learn how we approach safety", no: "Les om hvordan vi arbeider med trygghet" },
  },
  why: {
    heading: { en: "Why Ikke Alene", no: "Hvorfor Ikke Alene" },
    paragraphs: [
      {
        en: "People do not always say directly when they are struggling. Sometimes the signs are subtle. Sometimes they do not know how to begin the conversation, and the people around them may not know how to respond.",
        no: "Mennesker sier ikke alltid direkte fra når de har det vanskelig. Noen ganger er tegnene små. Noen ganger vet man ikke hvordan samtalen skal begynne, og menneskene rundt vet kanskje ikke hvordan de skal reagere.",
      },
      {
        en: "Ikke Alene begins with a simple belief: reaching out should feel easier, human connection should remain central, and support should be available before a situation becomes overwhelming.",
        no: "Ikke Alene bygger på en enkel tanke: det bør være lettere å ta kontakt, menneskelig forbindelse skal stå i sentrum, og støtte bør være tilgjengelig før situasjonen blir overveldende.",
      },
    ],
  },
  vision: {
    heading: { en: "What Ikke Alene could become", no: "Hva Ikke Alene kan bli" },
    cards: [
      {
        icon: "MessageCircle",
        title: { en: "Simple check-ins", no: "Enkle innsjekker" },
        text: {
          en: "A private and uncomplicated way for people to reflect on and express how they are feeling.",
          no: "En privat og enkel måte å reflektere over og uttrykke hvordan man har det.",
        },
      },
      {
        icon: "Users",
        title: { en: "Trusted connections", no: "Personer du stoler på" },
        text: {
          en: "Consent-based ways to stay connected with selected friends, family members or other trusted people.",
          no: "Samtykkebaserte måter å holde kontakt med utvalgte venner, familiemedlemmer eller andre personer man stoler på.",
        },
      },
      {
        icon: "Compass",
        title: { en: "Earlier support", no: "Tidligere støtte" },
        text: {
          en: "Clear guidance that can help people identify appropriate support services and take the next step.",
          no: "Tydelig veiledning som kan hjelpe mennesker med å finne relevante støttetjenester og ta neste steg.",
        },
      },
      {
        icon: "HeartHandshake",
        title: { en: "Human-centred technology", no: "Menneskesentrert teknologi" },
        text: {
          en: "Technology designed to support communication and connection—not replace people, relationships or professional care.",
          no: "Teknologi utviklet for å støtte kommunikasjon og kontakt – ikke erstatte mennesker, relasjoner eller profesjonell hjelp.",
        },
      },
    ],
    note: {
      en: "These are possible directions for future research and development, not confirmed product features.",
      no: "Dette er mulige retninger for fremtidig forskning og utvikling, ikke bekreftede produktfunksjoner.",
    },
  },
  principles: {
    heading: { en: "Principles before features", no: "Prinsipper før funksjoner" },
    intro: {
      en: "Because Ikke Alene concerns sensitive situations, safety, dignity and responsibility must come before speed or technical ambition.",
      no: "Fordi Ikke Alene berører sårbare situasjoner, må trygghet, verdighet og ansvar komme før hastighet og tekniske ambisjoner.",
    },
    items: [
      { en: "Privacy by design", no: "Personvern som grunnprinsipp" },
      { en: "Clear and informed consent", no: "Tydelig og informert samtykke" },
      { en: "User control", no: "Brukerkontroll" },
      { en: "Human connection first", no: "Menneskelig kontakt først" },
      { en: "Professional guidance", no: "Faglig veiledning" },
      { en: "Transparency and accountability", no: "Åpenhet og ansvarlighet" },
      { en: "Accessibility and inclusion", no: "Tilgjengelighet og inkludering" },
      { en: "Careful testing and evaluation", no: "Forsiktig testing og evaluering" },
    ],
  },
  boundaries: {
    heading: { en: "Clear boundaries", no: "Tydelige grenser" },
    paragraphs: [
      {
        en: "Ikke Alene is not intended to diagnose mental-health conditions, assess whether someone is in danger, replace healthcare professionals or provide emergency assistance.",
        no: "Ikke Alene skal ikke diagnostisere psykiske lidelser, vurdere om noen er i fare, erstatte helsepersonell eller tilby akutt hjelp.",
      },
      {
        en: "Any future solution must communicate its limitations clearly and direct people towards qualified and appropriate support when needed.",
        no: "En eventuell fremtidig løsning må kommunisere begrensningene tydelig og vise mennesker videre til kvalifisert og relevant hjelp når det er nødvendig.",
      },
    ],
  },
  status: {
    heading: { en: "Where we are today", no: "Hvor vi står i dag" },
    paragraphs: [
      {
        en: "Ikke Alene is currently an early-stage vision. There is no public product or healthcare service available today.",
        no: "Ikke Alene er foreløpig en visjon i en tidlig fase. Det finnes i dag ingen offentlig løsning eller helsetjeneste.",
      },
      {
        en: "Before development, the initiative requires research, ethical assessment, privacy evaluation, professional mental-health input, user involvement and collaboration with relevant organisations.",
        no: "Før utvikling krever initiativet forskning, etiske vurderinger, personvernsvurderinger, faglige innspill fra psykisk helse-feltet, brukermedvirkning og samarbeid med relevante organisasjoner.",
      },
    ],
    roadmap: [
      { en: "Listen and learn", no: "Lytte og lære" },
      { en: "Build professional partnerships", no: "Etablere faglige samarbeid" },
      { en: "Define safety and privacy requirements", no: "Definere krav til trygghet og personvern" },
      { en: "Explore and test concepts responsibly", no: "Utforske og teste konsepter på en ansvarlig måte" },
      { en: "Decide whether and how to proceed", no: "Vurdere om og hvordan initiativet skal videreføres" },
    ],
  },
  collaborate: {
    heading: { en: "Help shape the vision responsibly", no: "Bidra til å forme visjonen på en ansvarlig måte" },
    text: {
      en: "We are interested in conversations with qualified mental-health professionals, researchers, non-profit organisations, privacy and ethics specialists, responsible technology contributors and people with relevant lived experience.",
      no: "Vi ønsker dialog med kvalifisert helsepersonell innen psykisk helse, forskere, ideelle organisasjoner, eksperter på personvern og etikk, ansvarlige teknologibidragere og personer med relevant erfaringskompetanse.",
    },
    interests: [
      { en: "Mental-health expertise", no: "Fagkompetanse innen psykisk helse" },
      { en: "Research", no: "Forskning" },
      { en: "Ethics and privacy", no: "Etikk og personvern" },
      { en: "Non-profit partnership", no: "Samarbeid med ideell organisasjon" },
      { en: "Technology", no: "Teknologi" },
      { en: "Lived-experience contribution", no: "Erfaringskompetanse" },
      { en: "Other", no: "Annet" },
    ],
    form: {
      name: { en: "Name", no: "Navn" },
      email: { en: "Email", no: "E-post" },
      organisation: { en: "Organisation (optional)", no: "Organisasjon (valgfritt)" },
      interest: { en: "Area of interest", no: "Interesseområde" },
      message: { en: "Message", no: "Melding" },
      consent: {
        en: "I understand that Ikke Alene is an early-stage vision and not a healthcare or emergency service.",
        no: "Jeg forstår at Ikke Alene er en visjon i en tidlig fase og ikke en helse- eller akuttjeneste.",
      },
      submit: { en: "Start a conversation", no: "Start en samtale" },
      sending: { en: "Sending…", no: "Sender…" },
      helper: {
        en: "Please do not submit medical information or details about an urgent or personal crisis through this form.",
        no: "Vennligst ikke send medisinske opplysninger eller informasjon om en akutt eller personlig krise gjennom dette skjemaet.",
      },
      success: { en: "Thank you — we'll be in touch soon.", no: "Takk — vi tar kontakt snart." },
      error: { en: "Something went wrong. Please try again.", no: "Noe gikk galt. Prøv igjen." },
    },
  },
  footerDisclaimer: {
    en: "Ikke Alene is an early-stage social-impact vision from Jorviko. It is not a healthcare provider, diagnostic tool, crisis service or replacement for professional support.",
    no: "Ikke Alene er en samfunnsrettet visjon i en tidlig fase fra Jorviko. Initiativet er ikke en helsetjeneste, et diagnostisk verktøy, en akuttjeneste eller en erstatning for profesjonell hjelp.",
  },
};
